module.exports = __webpack_public_path__ + "img/1.516cb910.jpg";